import { useTranslation } from 'react-i18next';
import { Collapse, Stack, Typography } from '@mui/material';

import { Loader } from '../../../atoms/loader/Loader';
import { MplPaper } from '../../../molecules/MplPaper';

import { useDriverFeedbackContext } from './DriverFeedbackProvider';
import { NoRatingSvg } from './NoRatingSvg';

export const NoRatingBlock = () => {
	const { t } = useTranslation('profile');
	const { isLoading } = useDriverFeedbackContext();

	return (
		<MplPaper
			color="primary.main"
			gap={2}
			textAlign="center"
			alignItems="center"
		>
			<NoRatingSvg />
			<Stack gap={1}>
				<Typography variant="subtitle">
					{t('feedback.no_feedback_title')}
				</Typography>
				<Typography variant="caption">
					{t('feedback.no_feedback_content')}
				</Typography>
			</Stack>
			<Collapse in={isLoading}>
				<Loader />
			</Collapse>
		</MplPaper>
	);
};
